import { flattenCapAlert } from "../utils/alertUtils";

export default {
  setAlerts(state, alerts) {
    state.alerts = alerts;
  },
  SET_ALERTS(state, alerts) {
    // Convert server alert format to display format
    const displayAlerts = alerts.map(flattenCapAlert);
    state.alerts = displayAlerts;
  },
  selectAlert(state, alert) {
    state.selectedAlert = alert;
  },
  setLanguage(state, lang) {
    state.language = lang;
  },
  updateLastKeepAlive(state, timeString) {
    state.lastKeepAlive = timeString;
  },
  // Statistics mutations
  setTotalMessages(state, total) {
    state.totalMessages = total;
  },
  setAverageMessageRate(state, rate) {
    state.averageMessageRate = rate;
  },
  setStatisticsInterval(state, interval) {
    state.statisticsInterval = interval;
  },

  // Layer version mutations
  setLayerVersion(state, version) {
    state.layerVersion = version;
  },

  // History mutations
  addHistoryAlerts(state, alerts) {
    state.alerts = [...state.alerts, ...alerts];
  },

  // WebSocket mutations
  SET_WEBSOCKET: (state, websocket) => {
    state.websocket = websocket;
  },
  SET_WEBSOCKET_CONNECTED: (state, connected) => {
    state.websocketConnected = connected;
  },
  ADD_ALERT: (state, alert) => {
    const flatAlert = flattenCapAlert(alert);
    // Optionally add a local unique ID if needed
    flatAlert._localId = flatAlert.identifier || Date.now().toString();
    // Always keep the raw XML for the XML viewer
    flatAlert.rawXml = flatAlert.xmlContent || flatAlert.rawXml || "";
    state.alerts.push(flatAlert);
  },
  REMOVE_ALERT: (state, identifier) => {
    // Find and remove the alert by identifier
    console.log(state.alerts);
    const index = state.alerts.findIndex(
      (alert) => alert.identifier === identifier
    );
    if (index !== -1) {
      state.alerts.splice(index, 1);
    }
  },
  SET_LAST_KEEP_ALIVE: (state, timestamp) => {
    state.lastKeepAlive = timestamp;
  },
  RESET_LAST_KEEP_ALIVE: (state) => {
    state.lastKeepAlive = null;
  },
  SET_LAYER_VERSION: (state, layerVersion) => {
    state.layerVersion = layerVersion;
  },
  SET_CONNECTION_STATUS: (state, status) => {
    state.connectionStatus = status;
  },
  SET_HISTORY_DATA: (state, history) => {
    state.historyData = history;
  },
  SET_HISTORY_REQUEST_ID: (state, requestId) => {
    state.historyRequestId = requestId;
  },
  SET_SHAPEFILE_CONTENT: (state, content) => {
    state.shapefileContent = content;
  },
  SET_SHAPEFILE_VERSION: (state, version) => {
    state.shapefileVersion = version;
  },
  SET_SHAPEFILE_VERSION_RESPONSE: (state, response) => {
    state.shapefileVersionResponse = response;
  },
  SET_HISTORY_REQUEST: (state, request) => {
    state.historyRequest = request;
  },
  SET_HISTORY_RESPONSE: (state, response) => {
    state.historyResponse = response;
  },
  setUiTtlMinutes(state, minutes) {
    state.uiTtlMinutes = minutes;
  },
  // Auth mutations
  SET_AUTH(state, { token, username }) {
    state.authToken = token;
    state.authUser = username;
    state.isAuthenticated = true;
  },
  CLEAR_AUTH(state) {
    state.authToken = null;
    state.authUser = null;
    state.isAuthenticated = false;
  },
};
